import { render, staticRenderFns } from "./questions.vue?vue&type=template&id=3b3fd44e&scoped=true&"
import script from "./questions.vue?vue&type=script&lang=js&"
export * from "./questions.vue?vue&type=script&lang=js&"
import style0 from "./questions.vue?vue&type=style&index=0&id=3b3fd44e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3fd44e",
  null
  
)

export default component.exports